/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BillOfOperationsUsageDto,
  CheckImageDto,
  CheckImageUploadBodyDto,
  OperationBulkUpdateDto,
  OperationCategoryDto,
  OperationChecksDraftDto,
  OperationChecksDraftUpdateDto,
  OperationCreateInputDto,
  OperationDetailDto,
  OperationDetailsDraftDto,
  OperationDetailsDraftUpdateDto,
  OperationListItemDto,
  OperationReleaseTargetDto,
  OperationReorderInputDto,
  OperationStationDto,
  OperationStationToggleDto,
  OperationStationToggleResultDto,
  OperationStationsDraftCommitResultDto,
  OperationStationsDraftDto,
  OperationStationsDraftUpdateDto,
  OperationSubCategoryDto,
  OperationUpdateDto,
  OperationsControllerCreateOperation201,
  OperationsControllerListOperationSubCategoriesParams,
  OperationsControllerListOperationsParams,
  OperationsControllerUploadCheckImageParams,
  RelevanceRuleDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns the global list of operation categories used to populate the create-operation form. Categories are not partner-scoped — a single global enum-like table.
 * @summary List operation categories
 */
export type operationsControllerListOperationCategoriesResponse200 = {
  data: OperationCategoryDto[]
  status: 200
}
    
export type operationsControllerListOperationCategoriesResponseSuccess = (operationsControllerListOperationCategoriesResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListOperationCategoriesResponse = (operationsControllerListOperationCategoriesResponseSuccess)

export const getOperationsControllerListOperationCategoriesUrl = () => {


  

  return `/operations/categories`
}

export const operationsControllerListOperationCategories = async ( options?: RequestInit): Promise<operationsControllerListOperationCategoriesResponse> => {
  
  return customFetch<operationsControllerListOperationCategoriesResponse>(getOperationsControllerListOperationCategoriesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOperationsControllerListOperationCategoriesQueryKey = () => {
    return [
    `/operations/categories`
    ] as const;
    }

    
export const getOperationsControllerListOperationCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>> = ({ signal }) => operationsControllerListOperationCategories({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListOperationCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>>
export type OperationsControllerListOperationCategoriesQueryError = unknown


export function useOperationsControllerListOperationCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationCategories>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationCategories>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List operation categories
 */

export function useOperationsControllerListOperationCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListOperationCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List operation categories
 */
export const prefetchOperationsControllerListOperationCategoriesQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListOperationCategoriesQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getOperationsControllerListOperationCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>> = ({ signal }) => operationsControllerListOperationCategories({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListOperationCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>>
export type OperationsControllerListOperationCategoriesSuspenseQueryError = unknown


export function useOperationsControllerListOperationCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List operation categories
 */

export function useOperationsControllerListOperationCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListOperationCategoriesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the global list of operation sub-categories. When `operation_category` is provided, filters to sub-categories belonging to that category. Used by the operation form's cascading sub-category dropdown.
 * @summary List operation sub-categories
 */
export type operationsControllerListOperationSubCategoriesResponse200 = {
  data: OperationSubCategoryDto[]
  status: 200
}
    
export type operationsControllerListOperationSubCategoriesResponseSuccess = (operationsControllerListOperationSubCategoriesResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListOperationSubCategoriesResponse = (operationsControllerListOperationSubCategoriesResponseSuccess)

export const getOperationsControllerListOperationSubCategoriesUrl = (params?: OperationsControllerListOperationSubCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/operations/sub-categories?${stringifiedParams}` : `/operations/sub-categories`
}

export const operationsControllerListOperationSubCategories = async (params?: OperationsControllerListOperationSubCategoriesParams, options?: RequestInit): Promise<operationsControllerListOperationSubCategoriesResponse> => {
  
  return customFetch<operationsControllerListOperationSubCategoriesResponse>(getOperationsControllerListOperationSubCategoriesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOperationsControllerListOperationSubCategoriesQueryKey = (params?: OperationsControllerListOperationSubCategoriesParams,) => {
    return [
    `/operations/sub-categories`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getOperationsControllerListOperationSubCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationSubCategoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>> = ({ signal }) => operationsControllerListOperationSubCategories(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListOperationSubCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>>
export type OperationsControllerListOperationSubCategoriesQueryError = unknown


export function useOperationsControllerListOperationSubCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params: undefined |  OperationsControllerListOperationSubCategoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationSubCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationSubCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List operation sub-categories
 */

export function useOperationsControllerListOperationSubCategories<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListOperationSubCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List operation sub-categories
 */
export const prefetchOperationsControllerListOperationSubCategoriesQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 queryClient: QueryClient, params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListOperationSubCategoriesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getOperationsControllerListOperationSubCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationSubCategoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>> = ({ signal }) => operationsControllerListOperationSubCategories(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListOperationSubCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>>
export type OperationsControllerListOperationSubCategoriesSuspenseQueryError = unknown


export function useOperationsControllerListOperationSubCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params: undefined |  OperationsControllerListOperationSubCategoriesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationSubCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationSubCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List operation sub-categories
 */

export function useOperationsControllerListOperationSubCategoriesSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError = unknown>(
 params?: OperationsControllerListOperationSubCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationSubCategories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListOperationSubCategoriesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the current version of every operation owned by the partner. Optionally filtered by name, location, Product Type, and archived state. Location filters match where the operation is enabled. Product Type matches current released Run Sheets. Each row includes the unfiltered count of non-archived current Run Sheets containing the operation.
 * @summary List operations for a partner
 */
export type operationsControllerListOperationsResponse200 = {
  data: OperationListItemDto[]
  status: 200
}
    
export type operationsControllerListOperationsResponseSuccess = (operationsControllerListOperationsResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListOperationsResponse = (operationsControllerListOperationsResponseSuccess)

export const getOperationsControllerListOperationsUrl = (params: OperationsControllerListOperationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/operations?${stringifiedParams}` : `/operations`
}

export const operationsControllerListOperations = async (params: OperationsControllerListOperationsParams, options?: RequestInit): Promise<operationsControllerListOperationsResponse> => {
  
  return customFetch<operationsControllerListOperationsResponse>(getOperationsControllerListOperationsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOperationsControllerListOperationsQueryKey = (params?: OperationsControllerListOperationsParams,) => {
    return [
    `/operations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getOperationsControllerListOperationsQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperations>>> = ({ signal }) => operationsControllerListOperations(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperations>>>
export type OperationsControllerListOperationsQueryError = unknown


export function useOperationsControllerListOperations<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperations>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperations<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperations>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperations<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List operations for a partner
 */

export function useOperationsControllerListOperations<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListOperationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List operations for a partner
 */
export const prefetchOperationsControllerListOperationsQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 queryClient: QueryClient, params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListOperationsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getOperationsControllerListOperationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperations>>> = ({ signal }) => operationsControllerListOperations(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListOperationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperations>>>
export type OperationsControllerListOperationsSuspenseQueryError = unknown


export function useOperationsControllerListOperationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List operations for a partner
 */

export function useOperationsControllerListOperationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperations>>, TError = unknown>(
 params: OperationsControllerListOperationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListOperationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Inserts both an operations row and a v1 operation_versions row in a single transaction. The new operation is immediately editable from /operations/:operation_id and can be added to a Run Sheet via the matrix.
 * @summary Create a new operation
 */
export type operationsControllerCreateOperationResponse201 = {
  data: OperationsControllerCreateOperation201
  status: 201
}

export type operationsControllerCreateOperationResponse400 = {
  data: void
  status: 400
}
    
export type operationsControllerCreateOperationResponseSuccess = (operationsControllerCreateOperationResponse201) & {
  headers: Headers;
};
export type operationsControllerCreateOperationResponseError = (operationsControllerCreateOperationResponse400) & {
  headers: Headers;
};

export type operationsControllerCreateOperationResponse = (operationsControllerCreateOperationResponseSuccess | operationsControllerCreateOperationResponseError)

export const getOperationsControllerCreateOperationUrl = () => {


  

  return `/operations`
}

export const operationsControllerCreateOperation = async (operationCreateInputDto: OperationCreateInputDto, options?: RequestInit): Promise<operationsControllerCreateOperationResponse> => {
  
  return customFetch<operationsControllerCreateOperationResponse>(getOperationsControllerCreateOperationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationCreateInputDto,)
  }
);}




export const getOperationsControllerCreateOperationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCreateOperation>>, TError,{data: OperationCreateInputDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCreateOperation>>, TError,{data: OperationCreateInputDto}, TContext> => {

const mutationKey = ['operationsControllerCreateOperation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerCreateOperation>>, {data: OperationCreateInputDto}> = (props) => {
          const {data} = props ?? {};

          return  operationsControllerCreateOperation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerCreateOperationMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerCreateOperation>>>
    export type OperationsControllerCreateOperationMutationBody = OperationCreateInputDto
    export type OperationsControllerCreateOperationMutationError = void

    /**
 * @summary Create a new operation
 */
export const useOperationsControllerCreateOperation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCreateOperation>>, TError,{data: OperationCreateInputDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerCreateOperation>>,
        TError,
        {data: OperationCreateInputDto},
        TContext
      > => {

      const mutationOptions = getOperationsControllerCreateOperationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Reassigns operation_sequence across the partner's operations to match the supplied order. Index 0 maps to operation_sequence 1. The full ordered array of operation_ids must be supplied; the server overwrites all sequence values atomically. Run Sheet views continue to order by each Run Sheet's operation_order on the junction; only newly released Run Sheets pick up the partner-level sequence as their default.
 * @summary Reorder operations for a partner (admin only)
 */
export type operationsControllerReorderOperationsResponse204 = {
  data: void
  status: 204
}

export type operationsControllerReorderOperationsResponse400 = {
  data: void
  status: 400
}

export type operationsControllerReorderOperationsResponse403 = {
  data: void
  status: 403
}
    
export type operationsControllerReorderOperationsResponseSuccess = (operationsControllerReorderOperationsResponse204) & {
  headers: Headers;
};
export type operationsControllerReorderOperationsResponseError = (operationsControllerReorderOperationsResponse400 | operationsControllerReorderOperationsResponse403) & {
  headers: Headers;
};

export type operationsControllerReorderOperationsResponse = (operationsControllerReorderOperationsResponseSuccess | operationsControllerReorderOperationsResponseError)

export const getOperationsControllerReorderOperationsUrl = () => {


  

  return `/operations/sequence`
}

export const operationsControllerReorderOperations = async (operationReorderInputDto: OperationReorderInputDto, options?: RequestInit): Promise<operationsControllerReorderOperationsResponse> => {
  
  return customFetch<operationsControllerReorderOperationsResponse>(getOperationsControllerReorderOperationsUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationReorderInputDto,)
  }
);}




export const getOperationsControllerReorderOperationsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerReorderOperations>>, TError,{data: OperationReorderInputDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerReorderOperations>>, TError,{data: OperationReorderInputDto}, TContext> => {

const mutationKey = ['operationsControllerReorderOperations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerReorderOperations>>, {data: OperationReorderInputDto}> = (props) => {
          const {data} = props ?? {};

          return  operationsControllerReorderOperations(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerReorderOperationsMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerReorderOperations>>>
    export type OperationsControllerReorderOperationsMutationBody = OperationReorderInputDto
    export type OperationsControllerReorderOperationsMutationError = void

    /**
 * @summary Reorder operations for a partner (admin only)
 */
export const useOperationsControllerReorderOperations = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerReorderOperations>>, TError,{data: OperationReorderInputDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerReorderOperations>>,
        TError,
        {data: OperationReorderInputDto},
        TContext
      > => {

      const mutationOptions = getOperationsControllerReorderOperationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Accepts a single image (jpeg/png/gif/webp, ≤10 MB) and stores it in Google Cloud Storage under operations/checks_images/, inserting a matching public.images row. Returns an Image-shaped object the frontend embeds verbatim into an operation check via PATCH /operations/:operation_id. The stored image is served through GET /quality/evidence/file/:partner_name/{path} (GCS-first, Supabase legacy fallback) — no new serving code is required. partner_id is supplied in the query string because the multipart body is not parsed until after the guards run.
 * @summary Upload an image for an operation check
 */
export type operationsControllerUploadCheckImageResponse201 = {
  data: CheckImageDto
  status: 201
}

export type operationsControllerUploadCheckImageResponse400 = {
  data: void
  status: 400
}

export type operationsControllerUploadCheckImageResponse401 = {
  data: void
  status: 401
}

export type operationsControllerUploadCheckImageResponse403 = {
  data: void
  status: 403
}
    
export type operationsControllerUploadCheckImageResponseSuccess = (operationsControllerUploadCheckImageResponse201) & {
  headers: Headers;
};
export type operationsControllerUploadCheckImageResponseError = (operationsControllerUploadCheckImageResponse400 | operationsControllerUploadCheckImageResponse401 | operationsControllerUploadCheckImageResponse403) & {
  headers: Headers;
};

export type operationsControllerUploadCheckImageResponse = (operationsControllerUploadCheckImageResponseSuccess | operationsControllerUploadCheckImageResponseError)

export const getOperationsControllerUploadCheckImageUrl = (params: OperationsControllerUploadCheckImageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/operations/check-images?${stringifiedParams}` : `/operations/check-images`
}

export const operationsControllerUploadCheckImage = async (checkImageUploadBodyDto: CheckImageUploadBodyDto,
    params: OperationsControllerUploadCheckImageParams, options?: RequestInit): Promise<operationsControllerUploadCheckImageResponse> => {
    const formData = new FormData();
if(checkImageUploadBodyDto.title !== undefined) {
 formData.append(`title`, checkImageUploadBodyDto.title)
 }
if(checkImageUploadBodyDto.tags !== undefined) {
 checkImageUploadBodyDto.tags.forEach(value => formData.append(`tags`, value));
 }

  return customFetch<operationsControllerUploadCheckImageResponse>(getOperationsControllerUploadCheckImageUrl(params),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getOperationsControllerUploadCheckImageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>, TError,{data: CheckImageUploadBodyDto;params: OperationsControllerUploadCheckImageParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>, TError,{data: CheckImageUploadBodyDto;params: OperationsControllerUploadCheckImageParams}, TContext> => {

const mutationKey = ['operationsControllerUploadCheckImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>, {data: CheckImageUploadBodyDto;params: OperationsControllerUploadCheckImageParams}> = (props) => {
          const {data,params} = props ?? {};

          return  operationsControllerUploadCheckImage(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerUploadCheckImageMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>>
    export type OperationsControllerUploadCheckImageMutationBody = CheckImageUploadBodyDto
    export type OperationsControllerUploadCheckImageMutationError = void

    /**
 * @summary Upload an image for an operation check
 */
export const useOperationsControllerUploadCheckImage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>, TError,{data: CheckImageUploadBodyDto;params: OperationsControllerUploadCheckImageParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerUploadCheckImage>>,
        TError,
        {data: CheckImageUploadBodyDto;params: OperationsControllerUploadCheckImageParams},
        TContext
      > => {

      const mutationOptions = getOperationsControllerUploadCheckImageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns the operation row plus its current operation_versions row (work_time, headcount, category, pre-flight + in-process checks). Used by the Quality operation detail page.
 * @summary Get the current version of an operation
 */
export type operationsControllerGetOperationDetailResponse200 = {
  data: OperationDetailDto
  status: 200
}

export type operationsControllerGetOperationDetailResponse404 = {
  data: void
  status: 404
}
    
export type operationsControllerGetOperationDetailResponseSuccess = (operationsControllerGetOperationDetailResponse200) & {
  headers: Headers;
};
export type operationsControllerGetOperationDetailResponseError = (operationsControllerGetOperationDetailResponse404) & {
  headers: Headers;
};

export type operationsControllerGetOperationDetailResponse = (operationsControllerGetOperationDetailResponseSuccess | operationsControllerGetOperationDetailResponseError)

export const getOperationsControllerGetOperationDetailUrl = (operationId: string,) => {


  

  return `/operations/${operationId}`
}

export const operationsControllerGetOperationDetail = async (operationId: string, options?: RequestInit): Promise<operationsControllerGetOperationDetailResponse> => {
  
  return customFetch<operationsControllerGetOperationDetailResponse>(getOperationsControllerGetOperationDetailUrl(operationId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOperationsControllerGetOperationDetailQueryKey = (operationId?: string,) => {
    return [
    `/operations/${operationId}`
    ] as const;
    }

    
export const getOperationsControllerGetOperationDetailQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetOperationDetailQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>> = ({ signal }) => operationsControllerGetOperationDetail(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(operationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerGetOperationDetailQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>>
export type OperationsControllerGetOperationDetailQueryError = void


export function useOperationsControllerGetOperationDetail<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerGetOperationDetail<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerGetOperationDetail<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the current version of an operation
 */

export function useOperationsControllerGetOperationDetail<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerGetOperationDetailQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get the current version of an operation
 */
export const prefetchOperationsControllerGetOperationDetailQuery = async <TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerGetOperationDetailQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getOperationsControllerGetOperationDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetOperationDetailQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>> = ({ signal }) => operationsControllerGetOperationDetail(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerGetOperationDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>>
export type OperationsControllerGetOperationDetailSuspenseQueryError = void


export function useOperationsControllerGetOperationDetailSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerGetOperationDetailSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerGetOperationDetailSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the current version of an operation
 */

export function useOperationsControllerGetOperationDetailSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerGetOperationDetailSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type operationsControllerUpdateOperationResponse200 = {
  data: void
  status: 200
}
    
export type operationsControllerUpdateOperationResponseSuccess = (operationsControllerUpdateOperationResponse200) & {
  headers: Headers;
};
;

export type operationsControllerUpdateOperationResponse = (operationsControllerUpdateOperationResponseSuccess)

export const getOperationsControllerUpdateOperationUrl = (operationId: string,) => {


  

  return `/operations/${operationId}`
}

export const operationsControllerUpdateOperation = async (operationId: string,
    operationUpdateDto: OperationUpdateDto, options?: RequestInit): Promise<operationsControllerUpdateOperationResponse> => {
  
  return customFetch<operationsControllerUpdateOperationResponse>(getOperationsControllerUpdateOperationUrl(operationId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationUpdateDto,)
  }
);}




export const getOperationsControllerUpdateOperationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>, TError,{operationId: string;data: OperationUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>, TError,{operationId: string;data: OperationUpdateDto}, TContext> => {

const mutationKey = ['operationsControllerUpdateOperation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>, {operationId: string;data: OperationUpdateDto}> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerUpdateOperation(operationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerUpdateOperationMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>>
    export type OperationsControllerUpdateOperationMutationBody = OperationUpdateDto
    export type OperationsControllerUpdateOperationMutationError = unknown

    export const useOperationsControllerUpdateOperation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerUpdateOperation>>, TError,{operationId: string;data: OperationUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerUpdateOperation>>,
        TError,
        {operationId: string;data: OperationUpdateDto},
        TContext
      > => {

      const mutationOptions = getOperationsControllerUpdateOperationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns each Run Sheet whose current version includes this operation, with a work-orders-behind count so the operation detail page can surface where releases are needed. Each row also resolves the applied cycle time / headcount / cat-score for the product so users can see exactly what each downstream Run Sheet uses.
 * @summary List Run Sheets using this operation
 */
export type operationsControllerListBillsOfOperationsForOperationResponse200 = {
  data: BillOfOperationsUsageDto[]
  status: 200
}
    
export type operationsControllerListBillsOfOperationsForOperationResponseSuccess = (operationsControllerListBillsOfOperationsForOperationResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListBillsOfOperationsForOperationResponse = (operationsControllerListBillsOfOperationsForOperationResponseSuccess)

export const getOperationsControllerListBillsOfOperationsForOperationUrl = (operationId: string,) => {


  

  return `/operations/${operationId}/bills-of-operations`
}

export const operationsControllerListBillsOfOperationsForOperation = async (operationId: string, options?: RequestInit): Promise<operationsControllerListBillsOfOperationsForOperationResponse> => {
  
  return customFetch<operationsControllerListBillsOfOperationsForOperationResponse>(getOperationsControllerListBillsOfOperationsForOperationUrl(operationId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOperationsControllerListBillsOfOperationsForOperationQueryKey = (operationId?: string,) => {
    return [
    `/operations/${operationId}/bills-of-operations`
    ] as const;
    }

    
export const getOperationsControllerListBillsOfOperationsForOperationQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListBillsOfOperationsForOperationQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>> = ({ signal }) => operationsControllerListBillsOfOperationsForOperation(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(operationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListBillsOfOperationsForOperationQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>>
export type OperationsControllerListBillsOfOperationsForOperationQueryError = unknown


export function useOperationsControllerListBillsOfOperationsForOperation<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListBillsOfOperationsForOperation<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListBillsOfOperationsForOperation<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Run Sheets using this operation
 */

export function useOperationsControllerListBillsOfOperationsForOperation<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListBillsOfOperationsForOperationQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List Run Sheets using this operation
 */
export const prefetchOperationsControllerListBillsOfOperationsForOperationQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListBillsOfOperationsForOperationQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getOperationsControllerListBillsOfOperationsForOperationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListBillsOfOperationsForOperationQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>> = ({ signal }) => operationsControllerListBillsOfOperationsForOperation(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListBillsOfOperationsForOperationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>>
export type OperationsControllerListBillsOfOperationsForOperationSuspenseQueryError = unknown


export function useOperationsControllerListBillsOfOperationsForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListBillsOfOperationsForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListBillsOfOperationsForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Run Sheets using this operation
 */

export function useOperationsControllerListBillsOfOperationsForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListBillsOfOperationsForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListBillsOfOperationsForOperationSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Resolves the Run Sheets a release of this operation should update, given the operation's CURRENT staged relevance rules and overrides — including Run Sheets that would NEWLY gain the operation (a brand-new rule no released version reflects yet), plus Run Sheets that would lose or re-point it. Unlike GET :operation_id/bills-of-operations (which only reports Run Sheets whose released version already lists the operation), this is what the operation release wizard should enumerate so a zero-work-order "golden path" release still has targets. Each entry is a valid POST /change-control/runs/bill-of-operations-release target; currently_includes_operation=false with change=add is the newly-included case.
 * @summary List Run Sheets a release of this operation should target
 */
export type operationsControllerListOperationReleaseTargetsResponse200 = {
  data: OperationReleaseTargetDto[]
  status: 200
}

export type operationsControllerListOperationReleaseTargetsResponse404 = {
  data: void
  status: 404
}
    
export type operationsControllerListOperationReleaseTargetsResponseSuccess = (operationsControllerListOperationReleaseTargetsResponse200) & {
  headers: Headers;
};
export type operationsControllerListOperationReleaseTargetsResponseError = (operationsControllerListOperationReleaseTargetsResponse404) & {
  headers: Headers;
};

export type operationsControllerListOperationReleaseTargetsResponse = (operationsControllerListOperationReleaseTargetsResponseSuccess | operationsControllerListOperationReleaseTargetsResponseError)

export const getOperationsControllerListOperationReleaseTargetsUrl = (operationId: string,) => {


  

  return `/operations/${operationId}/release-targets`
}

export const operationsControllerListOperationReleaseTargets = async (operationId: string, options?: RequestInit): Promise<operationsControllerListOperationReleaseTargetsResponse> => {
  
  return customFetch<operationsControllerListOperationReleaseTargetsResponse>(getOperationsControllerListOperationReleaseTargetsUrl(operationId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOperationsControllerListOperationReleaseTargetsQueryKey = (operationId?: string,) => {
    return [
    `/operations/${operationId}/release-targets`
    ] as const;
    }

    
export const getOperationsControllerListOperationReleaseTargetsQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationReleaseTargetsQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>> = ({ signal }) => operationsControllerListOperationReleaseTargets(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(operationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListOperationReleaseTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>>
export type OperationsControllerListOperationReleaseTargetsQueryError = void


export function useOperationsControllerListOperationReleaseTargets<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationReleaseTargets<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationReleaseTargets<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Run Sheets a release of this operation should target
 */

export function useOperationsControllerListOperationReleaseTargets<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListOperationReleaseTargetsQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List Run Sheets a release of this operation should target
 */
export const prefetchOperationsControllerListOperationReleaseTargetsQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListOperationReleaseTargetsQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getOperationsControllerListOperationReleaseTargetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListOperationReleaseTargetsQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>> = ({ signal }) => operationsControllerListOperationReleaseTargets(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListOperationReleaseTargetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>>
export type OperationsControllerListOperationReleaseTargetsSuspenseQueryError = void


export function useOperationsControllerListOperationReleaseTargetsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationReleaseTargetsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListOperationReleaseTargetsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Run Sheets a release of this operation should target
 */

export function useOperationsControllerListOperationReleaseTargetsSuspense<TData = Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListOperationReleaseTargets>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListOperationReleaseTargetsSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns every operation_relevance_rules row whose operation_id matches, across all products / containers. The operation detail page renders this list so users can see which container selections pull this operation onto products. Read-only here — write paths (POST/DELETE on /boo/rules) stay admin-gated.
 * @summary List relevance rules targeting this operation
 */
export type operationsControllerListRulesForOperationResponse200 = {
  data: RelevanceRuleDto[]
  status: 200
}
    
export type operationsControllerListRulesForOperationResponseSuccess = (operationsControllerListRulesForOperationResponse200) & {
  headers: Headers;
};
;

export type operationsControllerListRulesForOperationResponse = (operationsControllerListRulesForOperationResponseSuccess)

export const getOperationsControllerListRulesForOperationUrl = (operationId: string,) => {


  

  return `/operations/${operationId}/rules`
}

export const operationsControllerListRulesForOperation = async (operationId: string, options?: RequestInit): Promise<operationsControllerListRulesForOperationResponse> => {
  
  return customFetch<operationsControllerListRulesForOperationResponse>(getOperationsControllerListRulesForOperationUrl(operationId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOperationsControllerListRulesForOperationQueryKey = (operationId?: string,) => {
    return [
    `/operations/${operationId}/rules`
    ] as const;
    }

    
export const getOperationsControllerListRulesForOperationQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListRulesForOperationQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>> = ({ signal }) => operationsControllerListRulesForOperation(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(operationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListRulesForOperationQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>>
export type OperationsControllerListRulesForOperationQueryError = unknown


export function useOperationsControllerListRulesForOperation<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListRulesForOperation<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListRulesForOperation<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List relevance rules targeting this operation
 */

export function useOperationsControllerListRulesForOperation<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListRulesForOperationQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List relevance rules targeting this operation
 */
export const prefetchOperationsControllerListRulesForOperationQuery = async <TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerListRulesForOperationQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getOperationsControllerListRulesForOperationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerListRulesForOperationQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>> = ({ signal }) => operationsControllerListRulesForOperation(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerListRulesForOperationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>>
export type OperationsControllerListRulesForOperationSuspenseQueryError = unknown


export function useOperationsControllerListRulesForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListRulesForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerListRulesForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List relevance rules targeting this operation
 */

export function useOperationsControllerListRulesForOperationSuspense<TData = Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError = unknown>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerListRulesForOperation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerListRulesForOperationSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns every live (non-archived) station belonging to the operation's partner, each with an `is_enabled` flag indicating whether the operation is currently enabled on that station (an `operations_stations` row exists). Powers the "Operation Enabled On" step. Archived stations, zones, and factories are excluded.
 * @summary List the partner stations this operation can be enabled on
 */
export type operationsControllerGetOperationStationsResponse200 = {
  data: OperationStationDto[]
  status: 200
}

export type operationsControllerGetOperationStationsResponse404 = {
  data: void
  status: 404
}
    
export type operationsControllerGetOperationStationsResponseSuccess = (operationsControllerGetOperationStationsResponse200) & {
  headers: Headers;
};
export type operationsControllerGetOperationStationsResponseError = (operationsControllerGetOperationStationsResponse404) & {
  headers: Headers;
};

export type operationsControllerGetOperationStationsResponse = (operationsControllerGetOperationStationsResponseSuccess | operationsControllerGetOperationStationsResponseError)

export const getOperationsControllerGetOperationStationsUrl = (operationId: string,) => {


  

  return `/operations/${operationId}/stations`
}

export const operationsControllerGetOperationStations = async (operationId: string, options?: RequestInit): Promise<operationsControllerGetOperationStationsResponse> => {
  
  return customFetch<operationsControllerGetOperationStationsResponse>(getOperationsControllerGetOperationStationsUrl(operationId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getOperationsControllerGetOperationStationsQueryKey = (operationId?: string,) => {
    return [
    `/operations/${operationId}/stations`
    ] as const;
    }

    
export const getOperationsControllerGetOperationStationsQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetOperationStationsQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>> = ({ signal }) => operationsControllerGetOperationStations(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(operationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerGetOperationStationsQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>>
export type OperationsControllerGetOperationStationsQueryError = void


export function useOperationsControllerGetOperationStations<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetOperationStations>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetOperationStations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerGetOperationStations<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof operationsControllerGetOperationStations>>,
          TError,
          Awaited<ReturnType<typeof operationsControllerGetOperationStations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerGetOperationStations<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List the partner stations this operation can be enabled on
 */

export function useOperationsControllerGetOperationStations<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerGetOperationStationsQueryOptions(operationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List the partner stations this operation can be enabled on
 */
export const prefetchOperationsControllerGetOperationStationsQuery = async <TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 queryClient: QueryClient, operationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getOperationsControllerGetOperationStationsQueryOptions(operationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getOperationsControllerGetOperationStationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationsControllerGetOperationStationsQueryKey(operationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>> = ({ signal }) => operationsControllerGetOperationStations(operationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OperationsControllerGetOperationStationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>>
export type OperationsControllerGetOperationStationsSuspenseQueryError = void


export function useOperationsControllerGetOperationStationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerGetOperationStationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOperationsControllerGetOperationStationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List the partner stations this operation can be enabled on
 */

export function useOperationsControllerGetOperationStationsSuspense<TData = Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError = void>(
 operationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof operationsControllerGetOperationStations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOperationsControllerGetOperationStationsSuspenseQueryOptions(operationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Toggles one `operations_stations` row for the operation. Enabling inserts the row (idempotent); disabling deletes it. Each real change is recorded by the AuditService. This is a direct write — it does NOT go through Run Sheet change control.
 * @summary Enable or disable this operation on a single station
 */
export type operationsControllerSetOperationStationEnabledResponse200 = {
  data: OperationStationToggleResultDto
  status: 200
}

export type operationsControllerSetOperationStationEnabledResponse400 = {
  data: void
  status: 400
}

export type operationsControllerSetOperationStationEnabledResponse404 = {
  data: void
  status: 404
}
    
export type operationsControllerSetOperationStationEnabledResponseSuccess = (operationsControllerSetOperationStationEnabledResponse200) & {
  headers: Headers;
};
export type operationsControllerSetOperationStationEnabledResponseError = (operationsControllerSetOperationStationEnabledResponse400 | operationsControllerSetOperationStationEnabledResponse404) & {
  headers: Headers;
};

export type operationsControllerSetOperationStationEnabledResponse = (operationsControllerSetOperationStationEnabledResponseSuccess | operationsControllerSetOperationStationEnabledResponseError)

export const getOperationsControllerSetOperationStationEnabledUrl = (operationId: string,) => {


  

  return `/operations/${operationId}/stations`
}

export const operationsControllerSetOperationStationEnabled = async (operationId: string,
    operationStationToggleDto: OperationStationToggleDto, options?: RequestInit): Promise<operationsControllerSetOperationStationEnabledResponse> => {
  
  return customFetch<operationsControllerSetOperationStationEnabledResponse>(getOperationsControllerSetOperationStationEnabledUrl(operationId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationStationToggleDto,)
  }
);}




export const getOperationsControllerSetOperationStationEnabledMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>, TError,{operationId: string;data: OperationStationToggleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>, TError,{operationId: string;data: OperationStationToggleDto}, TContext> => {

const mutationKey = ['operationsControllerSetOperationStationEnabled'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>, {operationId: string;data: OperationStationToggleDto}> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerSetOperationStationEnabled(operationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerSetOperationStationEnabledMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>>
    export type OperationsControllerSetOperationStationEnabledMutationBody = OperationStationToggleDto
    export type OperationsControllerSetOperationStationEnabledMutationError = void

    /**
 * @summary Enable or disable this operation on a single station
 */
export const useOperationsControllerSetOperationStationEnabled = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>, TError,{operationId: string;data: OperationStationToggleDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerSetOperationStationEnabled>>,
        TError,
        {operationId: string;data: OperationStationToggleDto},
        TContext
      > => {

      const mutationOptions = getOperationsControllerSetOperationStationEnabledMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Persists pending station enablement toggles to `operations.draft_*` — the same reused ENG-764 draft slot the Checks-page draft uses (no separate columns were added). Only one kind of draft (Checks or Stations) can be pending at a time; saving one supersedes the other. Intended to be called on a short debounce from the Stations editor so in-progress toggles survive a refresh before the user commits. Committing (`POST /operations/:operation_id/stations-draft/commit`) applies the changes and clears the draft back to null.
 * @summary Autosave a Stations-page draft
 */
export type operationsControllerSaveStationsDraftResponse200 = {
  data: OperationStationsDraftDto
  status: 200
}

export type operationsControllerSaveStationsDraftResponse400 = {
  data: void
  status: 400
}

export type operationsControllerSaveStationsDraftResponse404 = {
  data: void
  status: 404
}
    
export type operationsControllerSaveStationsDraftResponseSuccess = (operationsControllerSaveStationsDraftResponse200) & {
  headers: Headers;
};
export type operationsControllerSaveStationsDraftResponseError = (operationsControllerSaveStationsDraftResponse400 | operationsControllerSaveStationsDraftResponse404) & {
  headers: Headers;
};

export type operationsControllerSaveStationsDraftResponse = (operationsControllerSaveStationsDraftResponseSuccess | operationsControllerSaveStationsDraftResponseError)

export const getOperationsControllerSaveStationsDraftUrl = (operationId: string,) => {


  

  return `/operations/${operationId}/stations-draft`
}

export const operationsControllerSaveStationsDraft = async (operationId: string,
    operationStationsDraftUpdateDto: OperationStationsDraftUpdateDto, options?: RequestInit): Promise<operationsControllerSaveStationsDraftResponse> => {
  
  return customFetch<operationsControllerSaveStationsDraftResponse>(getOperationsControllerSaveStationsDraftUrl(operationId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationStationsDraftUpdateDto,)
  }
);}




export const getOperationsControllerSaveStationsDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>, TError,{operationId: string;data: OperationStationsDraftUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>, TError,{operationId: string;data: OperationStationsDraftUpdateDto}, TContext> => {

const mutationKey = ['operationsControllerSaveStationsDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>, {operationId: string;data: OperationStationsDraftUpdateDto}> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerSaveStationsDraft(operationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerSaveStationsDraftMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>>
    export type OperationsControllerSaveStationsDraftMutationBody = OperationStationsDraftUpdateDto
    export type OperationsControllerSaveStationsDraftMutationError = void

    /**
 * @summary Autosave a Stations-page draft
 */
export const useOperationsControllerSaveStationsDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>, TError,{operationId: string;data: OperationStationsDraftUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerSaveStationsDraft>>,
        TError,
        {operationId: string;data: OperationStationsDraftUpdateDto},
        TContext
      > => {

      const mutationOptions = getOperationsControllerSaveStationsDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Applies every staged station enablement/disablement from the pending draft (each real change recorded by the AuditService, same as a single live toggle) and clears the draft, all in one transaction. Like a single station toggle, this is a direct write that does NOT go through Run Sheet change control.
 * @summary Commit a pending Stations draft
 */
export type operationsControllerCommitStationsDraftResponse200 = {
  data: OperationStationsDraftCommitResultDto
  status: 200
}

export type operationsControllerCommitStationsDraftResponse400 = {
  data: void
  status: 400
}

export type operationsControllerCommitStationsDraftResponse404 = {
  data: void
  status: 404
}
    
export type operationsControllerCommitStationsDraftResponseSuccess = (operationsControllerCommitStationsDraftResponse200) & {
  headers: Headers;
};
export type operationsControllerCommitStationsDraftResponseError = (operationsControllerCommitStationsDraftResponse400 | operationsControllerCommitStationsDraftResponse404) & {
  headers: Headers;
};

export type operationsControllerCommitStationsDraftResponse = (operationsControllerCommitStationsDraftResponseSuccess | operationsControllerCommitStationsDraftResponseError)

export const getOperationsControllerCommitStationsDraftUrl = (operationId: string,) => {


  

  return `/operations/${operationId}/stations-draft/commit`
}

export const operationsControllerCommitStationsDraft = async (operationId: string, options?: RequestInit): Promise<operationsControllerCommitStationsDraftResponse> => {
  
  return customFetch<operationsControllerCommitStationsDraftResponse>(getOperationsControllerCommitStationsDraftUrl(operationId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getOperationsControllerCommitStationsDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>, TError,{operationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>, TError,{operationId: string}, TContext> => {

const mutationKey = ['operationsControllerCommitStationsDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>, {operationId: string}> = (props) => {
          const {operationId} = props ?? {};

          return  operationsControllerCommitStationsDraft(operationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerCommitStationsDraftMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>>
    
    export type OperationsControllerCommitStationsDraftMutationError = void

    /**
 * @summary Commit a pending Stations draft
 */
export const useOperationsControllerCommitStationsDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>, TError,{operationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerCommitStationsDraft>>,
        TError,
        {operationId: string},
        TContext
      > => {

      const mutationOptions = getOperationsControllerCommitStationsDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ENG-764. Persists the pre-flight / in-process check arrays to `operations.draft_*` columns WITHOUT bumping the operation version or cascading to Bills of Operations — unlike `PATCH /operations/:operation_id`, this never touches `operation_versions` (which is immutable-once-written by design). Intended to be called on a short debounce from the Checks editor so in-progress edits survive a refresh before the user commits. A commit (`PATCH /operations/:operation_id`) clears the draft back to null.
 * @summary Autosave a Checks-page draft
 */
export type operationsControllerSaveChecksDraftResponse200 = {
  data: OperationChecksDraftDto
  status: 200
}

export type operationsControllerSaveChecksDraftResponse400 = {
  data: void
  status: 400
}

export type operationsControllerSaveChecksDraftResponse404 = {
  data: void
  status: 404
}
    
export type operationsControllerSaveChecksDraftResponseSuccess = (operationsControllerSaveChecksDraftResponse200) & {
  headers: Headers;
};
export type operationsControllerSaveChecksDraftResponseError = (operationsControllerSaveChecksDraftResponse400 | operationsControllerSaveChecksDraftResponse404) & {
  headers: Headers;
};

export type operationsControllerSaveChecksDraftResponse = (operationsControllerSaveChecksDraftResponseSuccess | operationsControllerSaveChecksDraftResponseError)

export const getOperationsControllerSaveChecksDraftUrl = (operationId: string,) => {


  

  return `/operations/${operationId}/checks-draft`
}

export const operationsControllerSaveChecksDraft = async (operationId: string,
    operationChecksDraftUpdateDto: OperationChecksDraftUpdateDto, options?: RequestInit): Promise<operationsControllerSaveChecksDraftResponse> => {
  
  return customFetch<operationsControllerSaveChecksDraftResponse>(getOperationsControllerSaveChecksDraftUrl(operationId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationChecksDraftUpdateDto,)
  }
);}




export const getOperationsControllerSaveChecksDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>, TError,{operationId: string;data: OperationChecksDraftUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>, TError,{operationId: string;data: OperationChecksDraftUpdateDto}, TContext> => {

const mutationKey = ['operationsControllerSaveChecksDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>, {operationId: string;data: OperationChecksDraftUpdateDto}> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerSaveChecksDraft(operationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerSaveChecksDraftMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>>
    export type OperationsControllerSaveChecksDraftMutationBody = OperationChecksDraftUpdateDto
    export type OperationsControllerSaveChecksDraftMutationError = void

    /**
 * @summary Autosave a Checks-page draft
 */
export const useOperationsControllerSaveChecksDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>, TError,{operationId: string;data: OperationChecksDraftUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerSaveChecksDraft>>,
        TError,
        {operationId: string;data: OperationChecksDraftUpdateDto},
        TContext
      > => {

      const mutationOptions = getOperationsControllerSaveChecksDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Persists pending Details-form field values (name, category, work time, headcount, per-category cycle time/headcount, is_final) to `operations.draft_*` — the same reused ENG-764 draft slot the Checks-page draft uses (no separate columns were added). Only one kind of draft (Checks, Stations, or Details) can be pending at a time; saving one supersedes whichever was pending before. Intended to be called on a short debounce from the Details form so in-progress edits survive a refresh before the user commits. There is no separate commit endpoint for this draft kind: committing sends this same shape straight to `PATCH /operations/:operation_id`, which already clears this draft slot unconditionally.
 * @summary Autosave a Details-page draft
 */
export type operationsControllerSaveDetailsDraftResponse200 = {
  data: OperationDetailsDraftDto
  status: 200
}

export type operationsControllerSaveDetailsDraftResponse400 = {
  data: void
  status: 400
}

export type operationsControllerSaveDetailsDraftResponse404 = {
  data: void
  status: 404
}
    
export type operationsControllerSaveDetailsDraftResponseSuccess = (operationsControllerSaveDetailsDraftResponse200) & {
  headers: Headers;
};
export type operationsControllerSaveDetailsDraftResponseError = (operationsControllerSaveDetailsDraftResponse400 | operationsControllerSaveDetailsDraftResponse404) & {
  headers: Headers;
};

export type operationsControllerSaveDetailsDraftResponse = (operationsControllerSaveDetailsDraftResponseSuccess | operationsControllerSaveDetailsDraftResponseError)

export const getOperationsControllerSaveDetailsDraftUrl = (operationId: string,) => {


  

  return `/operations/${operationId}/details-draft`
}

export const operationsControllerSaveDetailsDraft = async (operationId: string,
    operationDetailsDraftUpdateDto: OperationDetailsDraftUpdateDto, options?: RequestInit): Promise<operationsControllerSaveDetailsDraftResponse> => {
  
  return customFetch<operationsControllerSaveDetailsDraftResponse>(getOperationsControllerSaveDetailsDraftUrl(operationId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationDetailsDraftUpdateDto,)
  }
);}




export const getOperationsControllerSaveDetailsDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>, TError,{operationId: string;data: OperationDetailsDraftUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>, TError,{operationId: string;data: OperationDetailsDraftUpdateDto}, TContext> => {

const mutationKey = ['operationsControllerSaveDetailsDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>, {operationId: string;data: OperationDetailsDraftUpdateDto}> = (props) => {
          const {operationId,data} = props ?? {};

          return  operationsControllerSaveDetailsDraft(operationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerSaveDetailsDraftMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>>
    export type OperationsControllerSaveDetailsDraftMutationBody = OperationDetailsDraftUpdateDto
    export type OperationsControllerSaveDetailsDraftMutationError = void

    /**
 * @summary Autosave a Details-page draft
 */
export const useOperationsControllerSaveDetailsDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>, TError,{operationId: string;data: OperationDetailsDraftUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerSaveDetailsDraft>>,
        TError,
        {operationId: string;data: OperationDetailsDraftUpdateDto},
        TContext
      > => {

      const mutationOptions = getOperationsControllerSaveDetailsDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type operationsControllerBulkUpdateResponse201 = {
  data: void
  status: 201
}
    
export type operationsControllerBulkUpdateResponseSuccess = (operationsControllerBulkUpdateResponse201) & {
  headers: Headers;
};
;

export type operationsControllerBulkUpdateResponse = (operationsControllerBulkUpdateResponseSuccess)

export const getOperationsControllerBulkUpdateUrl = () => {


  

  return `/operations/bulk-update`
}

export const operationsControllerBulkUpdate = async (operationBulkUpdateDto: OperationBulkUpdateDto, options?: RequestInit): Promise<operationsControllerBulkUpdateResponse> => {
  
  return customFetch<operationsControllerBulkUpdateResponse>(getOperationsControllerBulkUpdateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationBulkUpdateDto,)
  }
);}




export const getOperationsControllerBulkUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>, TError,{data: OperationBulkUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>, TError,{data: OperationBulkUpdateDto}, TContext> => {

const mutationKey = ['operationsControllerBulkUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>, {data: OperationBulkUpdateDto}> = (props) => {
          const {data} = props ?? {};

          return  operationsControllerBulkUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationsControllerBulkUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>>
    export type OperationsControllerBulkUpdateMutationBody = OperationBulkUpdateDto
    export type OperationsControllerBulkUpdateMutationError = unknown

    export const useOperationsControllerBulkUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationsControllerBulkUpdate>>, TError,{data: OperationBulkUpdateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof operationsControllerBulkUpdate>>,
        TError,
        {data: OperationBulkUpdateDto},
        TContext
      > => {

      const mutationOptions = getOperationsControllerBulkUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    